export const navigationTranslations = {
    en: {
        dashboard: 'Dashboard',
        orders: 'Orders',
        users: 'Users',
        settings: 'Settings',
        reports: 'Reports',
        reportsDescription: 'View and analyze your restaurant performance',
        salesReport: 'Sales Report',
        salesReportDescription: 'Daily and monthly sales analysis with top-selling items',
        itemsReport: 'Items Performance',
        itemsReportDescription: 'Item performance analysis and ranking by sales and revenue',
        categoriesReport: 'Category Analysis',
        categoriesReportDescription: 'Category performance and contribution to sales',
        timeReport: 'Time Analysis',
        timeReportDescription: 'Peak hours and order pattern analysis',
        generateReport: 'Generate Report',
        startDate: 'Start Date',
        endDate: 'End Date',
        reportGenerated: 'Report generated successfully',
        errorGeneratingReport: 'Failed to generate report',
        changeLanguage: 'Change Language',
        logout: 'Logout',
        restaurantName: 'Restaurant Admin'
    },
    ar: {
        dashboard: 'لوحة التحكم',
        orders: 'الطلبات',
        users: 'المستخدمين',
        settings: 'الإعدادات',
        reports: 'التقارير',
        reportsDescription: 'عرض وتحليل أداء المطعم',
        salesReport: 'تقرير المبيعات',
        salesReportDescription: 'تحليل المبيعات اليومية والشهرية مع تفاصيل المنتجات الأكثر مبيعاً',
        itemsReport: 'تقرير المنتجات',
        itemsReportDescription: 'تحليل أداء المنتجات وتصنيفها حسب المبيعات والإيرادات',
        categoriesReport: 'تقرير الأقسام',
        categoriesReportDescription: 'تحليل أداء الأقسام ومساهمتها في المبيعات',
        timeReport: 'تحليل الوقت',
        timeReportDescription: 'تحليل أوقات الذروة وأنماط الطلبات',
        generateReport: 'إنشاء التقرير',
        startDate: 'من تاريخ',
        endDate: 'إلى تاريخ',
        reportGenerated: 'تم إنشاء التقرير بنجاح',
        errorGeneratingReport: 'فشل في إنشاء التقرير',
        changeLanguage: 'تغيير اللغة',
        logout: 'تسجيل الخروج',
        restaurantName: 'إدارة المطعم'
    }
};
